import { VoyageDialogPopupManager } from '../../local_modules/voyage-dialog-popup/src/voyage-dialog-popup-manager';
import { ScheduleEntry, SimplifiedPortCall } from '../models/types/voyage-schedules-model.types';
import { RouteGeometry, VoyageRoutePointFeature } from "../models/voyage-routing-model";

export const ONE_DAY = 1000 * 60 * 60 * 24
export const ONE_MONTH = ONE_DAY * 31
export const THREE_MONTHS = ONE_MONTH * 3
export const SIX_MONTHS = ONE_MONTH * 6
export const TWELVE_MONTHS = ONE_MONTH * 12
export const DEFAULT_PLAYBACK = 3600;
export const PAST_TRAIL_ROTATION_FACTOR = 0.0174532925;

export function formatToTitleCase(text?: string): string {
    return text?.split(" ")
    .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ") ?? '';
}

export function debounce(callback: Function, wait?: number) {
    let timeout: number;
    return (...args: any[]) => {
        // @ts-ignore (implicit any for this)
        const context = this;
        clearTimeout(timeout);
        timeout = window.setTimeout(() => callback.apply(context, args), wait);
    };
}

// Simple delayfunction to wait for various events, e.g. a debounced input
// mostly used with testing
export const delay = (ms: number) => new Promise(res => setTimeout(res, ms))


export function ScrollTo(element: HTMLElement, to: number, duration: number) {
    let start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        startTime = new Date().getTime();

    let animateScroll = function(){
        currentTime = Math.min(new Date().getTime() - startTime, duration);

        const val = function(currentTime, start, change, duration) {
            currentTime /= duration/2;
            if (currentTime < 1) return change/2*currentTime*currentTime + start;
            currentTime--;
            return -change/2 * (currentTime*(currentTime-2) - 1) + start;
        }(currentTime, start, change, duration);
        element.scrollTop = val;
        if(currentTime < duration) window.requestAnimationFrame ? window.requestAnimationFrame(animateScroll) : window.setTimeout(animateScroll, 24);
    };

    animateScroll();
}

export function GetFormattedDate(date: string|number|Date) {
    const dateVal = new Date(date);
    const month = dateVal.toLocaleString('en-us', { month:'short', timeZone: 'UTC' });
    const timeOfDay = `${dateVal.getUTCHours().toString().padStart(2,'0')}:${dateVal.getUTCMinutes().toString().padStart(2,'0')}`;
    return `${dateVal.getUTCDate()} ${month} ${dateVal.getUTCFullYear()} ${timeOfDay}`;
}

export function GetFormattedLocalDateString(date: string | number, timezone: string){
    if(date == ''){
        return null;
    }
    const options: Intl.DateTimeFormatOptions = {
        timeZone: timezone,
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    };

    const formatter = new Intl.DateTimeFormat('en-GB', options);
    return formatter.format(new Date(date));
}

export function GetFormattedTimeWithDate(date: string|number|Date) {
    const dateVal = new Date(date);
    const month = dateVal.toLocaleString('en-us', { month:'short', timeZone: 'UTC' });
    const timeOfDay = `${dateVal.getUTCHours().toString().padStart(2,'0')}:${dateVal.getUTCMinutes().toString().padStart(2,'0')}`;
    return `${timeOfDay} ${dateVal.getUTCDate()} ${month} ${dateVal.getUTCFullYear()}`;
}

export function GetFormattedDateNoYear(date: string|number|Date) {
    const dateVal = new Date(date);
    const month = dateVal.toLocaleString('en-us', { month: 'short', timeZone: 'UTC' });
    const timeOfDay = `${dateVal.getUTCHours().toString().padStart(2,'0')}:${dateVal.getUTCMinutes().toString().padStart(2,'0')}`;
    return `${month} ${dateVal.getUTCDate()} ${timeOfDay}`;
}

export function GetUTCTimestamp(date: string|number|Date): string {
    const dateVal = new Date(date);
    return `${dateVal.getUTCHours().toString().padStart(2,'0')}:${dateVal.getUTCMinutes().toString().padStart(2,'0')}`;
}

export function ConvertDateToAnotherTimeZone(date: string, timezone: string) {
    const dateString = new Date(date).toLocaleString('en-US', {
        timeZone: timezone
    });

    const dateLocal = new Date(dateString);
    const dateUTC = Date.UTC(dateLocal.getFullYear(), 
                             dateLocal.getMonth(), 
                             dateLocal.getDate(), 
                             dateLocal.getHours(), 
                             dateLocal.getMinutes(), 
                             dateLocal.getSeconds());

    return dateUTC;
}

export function FormatDateToLocalTime(date: string | number, timezone: string) {
    const convertedDate = new Date(date);

    // Get the formatted date string in the specified timezone
    const dateString = convertedDate.toLocaleString('en-US', { timeZone: timezone });
    const dateStringUtc = new Date(dateString);
    // Get month and day from the converted date
    const month = convertedDate.toLocaleString('en-US', { timeZone: timezone, month: 'short' });
    const day = convertedDate.toLocaleString('en-US', { timeZone: timezone, day: 'numeric' });
    const dateLocal = new Date(dateString);
    const dateUTC = Date.UTC(dateLocal.getFullYear(),
        dateLocal.getMonth(),
        dateLocal.getDate(),
        dateLocal.getHours(),
        dateLocal.getMinutes(),
        dateLocal.getSeconds());

    const diff = Math.ceil((dateUTC - new Date(date).getTime()) / (1000 * 60 * 60));
    // Get the time components in 24-hour format
    const hours = dateStringUtc.getHours().toString().padStart(2, '0');
    const minutes = dateStringUtc.getMinutes().toString().padStart(2, '0');
    const timeOfDay = `${hours}:${minutes}`;

    return `${day} ${month} ${timeOfDay} LT (UTC ${diff > 0 ? "+" + diff : diff})`;
}

  export function FormatDateToLTFormat(date: string | number, timezone: string) {
    const convertedDate = new Date(date);
    
    const dateString = convertedDate.toLocaleString('en-US', {timeZone: timezone})
    const month = convertedDate.toLocaleString('en-us', { month: 'short' }); 
  
    const dateLocal = new Date(dateString);
    const dateUTC = Date.UTC(dateLocal.getFullYear(), 
                             dateLocal.getMonth(), 
                             dateLocal.getDate(), 
                             dateLocal.getHours(), 
                             dateLocal.getMinutes(), 
                             dateLocal.getSeconds());
  
    const diff = (dateUTC - new Date(date).getTime()) / (1000 * 60 * 60);
  
    const timeOfDay = `${dateLocal.getHours().toString().padStart(2,'0')}:${dateLocal.getUTCMinutes().toString().padStart(2,'0')}`;
    return `${dateLocal.getDate()} ${month} ${timeOfDay} LT`;
  }
  

export function GetFormattedLocalDate(dateStr: string) {
    // Input to this function is a date string with a time zone, e.g. 2019-07-01T12:00:00.000+01:00
    // We trim off the time zone information and rewrite it as UTC to prevent GetFormattedDate from converting it
    return GetFormattedDate(dateStr.substring(0, 19) + 'Z');
}

export function smartAge(ageInMilliseconds: number) {
    // Start with hours
    let duration = Math.floor(ageInMilliseconds / (60 * 60 * 1000));
    let label = (duration === 1 ? 'hour' : 'hours');

    // If above 24, convert to days
    if (duration >= 24) {
        duration = Math.floor(duration / 24);
        label = (duration === 1 ? 'day' : 'days');
    }

    return `${duration} ${label}`;
}

export function UUID() {
    // See https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
}

// Compares a and b
// Note: Assumes plain data inputs (ie. Objects, Arrays and basic types)
export function deepEqual(a: any, b: any): boolean
{
    if (a === b)
    {
        return true;
    }

    if (Number.isNaN(a) && Number.isNaN(b))
    {
        return true;
    }

    if (typeof(a) === "object" && a !== null)
    {
        if (Array.isArray(a))
        {
            if (!Array.isArray(b) || a.length !== b.length)
            {
                return false;
            }
            for (let i = 0; i < a.length; i++)
            {
                if (!deepEqual(a[i], b[i]))
                {
                    return false;
                }
            }
            return true;
        }
        else
        {
            // a is an Object
            if (typeof(b) !== "object" || b === null || Array.isArray(b))
            {
                return false;
            }
            if (Object.keys(a).length !== Object.keys(b).length)
            {
                return false;
            }
            for (const propName in a)
            {
                if (!(propName in b))
                {
                    return false;
                }
                if (!deepEqual(a[propName], b[propName]))
                {
                    return false;
                }
            }
            return true;
        }
    }
    
    return false;
}

// Creates a deep copy of the given object (while keeping type intact)
// Note: Assumes input that can be JSONified (ie. Objects, Arrays and basic types without circular references)
export function deepCopy<T>(a: T): T
{
    return JSON.parse(JSON.stringify(a));
}

// Reverse version of the arrays findIndex() function
export function findLastIndex<T>(array: Array<T>, callback: (element: T, index?: number, array?: Array<T>) => boolean): number
{
    for (let i = array.length-1; i >= 0; i--)
    {
        if (callback(array[i], i, array))
        {
            return i;
        }
    }
    return -1;
}

export function verifyETAOverlapWithDepartureTime(eta: number, scheduleEntry: ScheduleEntry, portCall: SimplifiedPortCall) {
    if (eta >= new Date(scheduleEntry.arrivalPortCall!.current!.departureAt).getTime()) {
        portCall.departureAt = new Date(eta + 60*60*1000).toISOString();

        VoyageDialogPopupManager.createDialog({
            headerText: ETAExeedsThePortCallDepartureTimeTitle,
            bodyText: "Departure time at arrival port has been advanced by 1h",
            acceptButtonText: "Ok",
        });
    }
}

export const ETAExeedsThePortCallDepartureTimeTitle = "ETA exceeds the port call departure time";

/**
 * @description takes a JS Date time stamp and pretty tells the user time lapsed since time.
 * @param timestamp The string that should be made human readable
 * @returns string (example: 5 minutes ago)
 */
export function prettyTimelapsed(timestamp?: string): string {
    if (!timestamp) {
        return '-'
    }

    const currentTs = (new Date()).getTime();
    const secondsLapsed = (currentTs - (new Date(timestamp)).getTime()) / 1000;

    if (secondsLapsed < 60) {
        return "less than 1 min.";
    } else if (secondsLapsed < 60 * 60) {
        return `${(secondsLapsed/60).toFixed(0)} min.`;
    } else if (secondsLapsed < (60 * 60 * 24)) {
        // toFixed is rounding number, so 1.49 will be rounded to 1
        if (secondsLapsed < (60 * 60 * 1.5)) {
            return `${(secondsLapsed/3600).toFixed(0)} hour`;
        }
        return `${(secondsLapsed/3600).toFixed(0)} hours`;
    }

    return `${(secondsLapsed / (60 * 60 * 24)).toFixed(0)} days`;
}


// returns the lastest week/year date from array of week/year strings
export function getLatestWeekDate(dates: string[]) {
    if (!dates || dates.length === 0) {
        return null;
    }
    
    return dates.map(d => d.split('/')).sort((a, b) => a[1].localeCompare(b[1]) || a[0].localeCompare(b[0]))[dates.length -1].join('/');
}

export function getWaypointsFromRoute(routeGeometry: RouteGeometry): VoyageRoutePointFeature[] {
    const copyPoints = JSON.parse(JSON.stringify(routeGeometry.filter(feature => feature.geometry.type === "Point" && feature.properties.type !== "Informational")));

    const legs = routeGeometry.filter(feature => feature.geometry.type === "LineString");

    for (let i = 0; i < legs.length; i++) {
        copyPoints[i].properties.leg_type = legs[i].properties.leg_type;
    }

    return copyPoints;
}

/**
 * knotsToMps
 * Converts nautical miles per hour (knots) to Meters pr. second.
 * @param knots Nautical miles per hour.
 * @returns number
 */
export function knotsToMps(knots: number) {
    return knots * 1852 / 3600
}
/**
 * mpsToKnots
 * Converts Meters pr. second to nautical miles per hour (knots).
 * @param mps Meters per. second.
 * @returns number
 */
export function mpsToKnots(mps: number) {
    return mps * 3600 / 1852
}

export const passagePlanPropertiesOnRoute = ["description", "reminders", "encCellsUsed", "booksAndTables", "chartsAndLightsNotes", "sailingDirections", "listOfRadioSignals", "listOfLights",
                                             "gpsEcdisRadarMap", "paperCharts", "pubCorrectedToWeek", "tideTables", "publicationsNotes", "mastersOrders"];

// Remove all special characters that are not compatible for html attributes
export function stringToHTMLAttribute(s: string) {
    return s.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\s\{\}\[\]\\\/]/gi, '').toLowerCase();
}

export function GetFormattedDateDayMonthTimeNoYear(date: string | number | Date) {
    const dateVal = new Date(date);
    const month = dateVal.toLocaleString('en-us', { month: 'short', timeZone: 'UTC' });
    const timeOfDay = `${dateVal.getUTCHours().toString().padStart(2, '0')}:${dateVal.getUTCMinutes().toString().padStart(2, '0')}`;
    return ` ${dateVal.getUTCDate()} ${month}  ${timeOfDay}`;
}

export function getFormattedDateTime(now: Date){
    let today = now.toLocaleString('en-us', { weekday: 'short', timeZone: 'UTC' });
    const timePart = `${
    now.getUTCHours().toString().padStart(2,'0')}:${
    now.getUTCMinutes().toString().padStart(2,'0')}`;

    const datePart = `${now.getUTCDate().toString().padStart(2,'0')},`;
    const offset = getTimeZone(now)

    return `${today} ${datePart} ${timePart} UTC (${offset} h)`;
}

export function getFormattedDateUTC(date = new Date()){
    const timePart = `${
    date.getUTCHours().toString().padStart(2,'0')}:${
    date.getUTCMinutes().toString().padStart(2,'0')}`;
    const month = date.toLocaleString('en-us', { month:'short', timeZone: 'UTC' });
    const datePart = `${date.getUTCDate().toString().padStart(2,'0')}`;
    return `${datePart} ${month} ${timePart} UTC`;
}

export function getWeatherFormattedDateTime(now: Date){
    const timePart = `${
    now.getUTCHours().toString().padStart(2,'0')}:${
    now.getUTCMinutes().toString().padStart(2,'0')}`;

    const datePart = `${now.getUTCDate().toString().padStart(2,'0')}`;
    const month = `${(now.getUTCMonth() + 1).toString().padStart(2,'0')}`;
    const offset = getTimeZone(now);

    return `${offset} (UTC ${timePart} - ${datePart}/${month})`;
}

export function getTimeZone(date: Date) {
    const timezoneOffset = date.getTimezoneOffset()
    const offset = Math.abs(timezoneOffset)
    const offsetOperator = timezoneOffset < 0 ? '+' : '-'
    const offsetHours = Math.floor(offset / 60).toString().padStart(2, '0')
    const offsetMinutes = Math.floor(offset % 60).toString().padStart(2, '0')
  
    return `${offsetOperator}${offsetHours}:${offsetMinutes}`
}

export function getUTCDateTimeString(timestamp: string){
    const date = new Date(timestamp);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2,"0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} UTC`;
}